import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TenderAcceptPage } from '@/features/subcontracts/tender-accept-page';

const searchSchema = z.object({
  token: z.string().optional().catch(undefined),
});

/** Public: an invitation to tender arrives by email before the person is signed in. */
export const Route = createFileRoute('/tenders/accept')({
  validateSearch: searchSchema,
  component: AcceptRoute,
});

function AcceptRoute() {
  const { token } = Route.useSearch();
  return <TenderAcceptPage token={token} />;
}
